var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoordashScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1774b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#ff3008"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c71238"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.33203,46.76276h25.45721c1.81451-.0191,3.29767,1.41785,3.31677,3.20685s-1.43536,3.25464-3.24982,3.27216h-17.5509c-.4989.00018-.94934.29883-1.1438.7583-.1922.45758-.08685.98602.26605,1.33502l7.87134,7.81238c.69891.69104,1.64252,1.07812,2.62537,1.0769h7.93829c10.32788,0,18.13708-10.89655,12.367-21.7135v.00476c-2.24304-4.1579-6.63196-6.74664-11.40479-6.73071H24.71307c-.4986.00201-.94763.30182-1.14069.76147-.19031.45703-.08441.98383.26764,1.33179l7.86658,7.80609c.69458.69135,1.64087,1.07849,2.62543,1.07849Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoordashScraper);
export default __webpack_public_path__ + "static/media/doordash-scraper.abc1a8c92c766cbb5fc4e13441912147.svg";
export { ForwardRef as ReactComponent };